import * as React from 'react'
import * as Tgcc from '../tgccGlobal'
import Radium, { StyleRoot } from 'radium'
import {ScreenDoor} from './ScreenDoor'

const boxStyle: React.CSSProperties = {
    height: '250px',
    width: '380px',
    position: 'absolute',
    top: '50%',
    marginTop: '-125px',
    left: '50%',
    marginLeft: '-190px',
    padding: '20px',
    backgroundColor: 'white',
    fontFamily: 'CenturyGothic',
    fontSize: '13px',
    textTransform: 'uppercase',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-around',
    '@media (max-width:414px)': {
        width:'350px',
    },
    '@media (max-width:375px)': {
        width:'338px',
        marginLeft:'-180px',
        padding:'10px'
    },
    '@media (max-width:320px)': {
        width:'290px',
        marginLeft:'-155px',
        padding:'10px'
    }
};

const titleStyle: React.CSSProperties = {
    display: 'flex',
    alignSelf: 'center',
    fontSize: '25px'
}
let titleScriptStyle = Object.assign( {}, titleStyle, {fontFamily: 'BarlowMedium', fontSize: '50px', textTransform: 'none'});

const msgStyle: React.CSSProperties = {
    display: 'flex',
    alignSelf: 'center',
    textAlign: 'center'
}
const style = Object.assign({},Tgcc.Styles.grayButton, {backgroundColor:'#5E6A74'});

export class MsgProps {
    Title: string;
    UseTitleScript?: boolean;
    Message1: string;
    Message2?: string;
    Error?: string;
    onContinue: () => void;
    btnStyle?:string;
}

    
class _Message extends React.Component<MsgProps, any> {
    
    keyPressed = (evt: React.KeyboardEvent<HTMLDivElement>) => {
        if(evt.key === 'Enter')
            if(this.props.onContinue)
                this.props.onContinue();
    }

    
    render(){
        var tStyle = this.props.UseTitleScript ? titleScriptStyle : titleStyle;
        var Title = this.props.Title ? <div style={tStyle}>{this.props.Title}</div> : null;
        const styleBtn = Object.assign({},Tgcc.Styles.grayButton, {backgroundColor:'#5E6A74'});

        var message1 = this.props.Message1 ? <div style={msgStyle}>{this.props.Message1}</div> : null;
        var message2 = this.props.Message2 ? <div style={msgStyle}>{this.props.Message2}</div> : null;
        var error = this.props.Error ? <div style={Tgcc.Styles.error}>{this.props.Error}</div> : null;
        var style = this.props.btnStyle ? styleBtn : Tgcc.Styles.grayButton;

        return(
            <div onKeyPress={this.keyPressed}>
            <ScreenDoor>
                <div style={boxStyle} >
                    {Title}
                    {error}
                    {message1}
                    {message2}
                    <button className='hoverBorder' style={style} onClick={this.props.onContinue}>Continue</button>
                </div>
            </ScreenDoor>
            </div>
        );
    }
}

export var Message = Radium(_Message);